import { useState, useEffect } from "react";

const ValidatorForm = ({
  managerAccounts,
  validationTypes,
  domainId,
  validatorToEdit,
  isSubmitting,
  onSubmit,
  onCancel,
}) => {
  const [selectedAccountId, setSelectedAccountId] = useState("");
  const [selectedValidationTypeId, setSelectedValidationTypeId] = useState("");
  const [errors, setErrors] = useState({});

  const isEditing = !!validatorToEdit;

  useEffect(() => {
    if (isEditing && validatorToEdit) {
      setSelectedAccountId(validatorToEdit.accountId?.toString() || "");
      setSelectedValidationTypeId(validatorToEdit.validationTypeId?.toString() || "");
    } else {
      setSelectedAccountId("");
      setSelectedValidationTypeId("");
    }
    setErrors({});
  }, [isEditing, validatorToEdit]);

  const validateForm = () => {
    const newErrors = {};
    if (!selectedAccountId) newErrors.accountId = "Veuillez sélectionner un manager.";
    if (!selectedValidationTypeId) newErrors.validationTypeId = "Veuillez sélectionner un type de validation.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    onSubmit({
      accountId: parseInt(selectedAccountId),
      domainId,
      validationTypeId: parseInt(selectedValidationTypeId),
      id: validatorToEdit?.id,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-body">
        {/* Sélection Manager */}
        <div className="mb-3">
          <label className="form-label fw-bold">Manager du Compte <span className="text-danger">*</span></label>
          <select
            className={`form-select form-control-lg ${errors.accountId ? "is-invalid" : ""}`}
            value={selectedAccountId}
            onChange={(e) => setSelectedAccountId(e.target.value)}
            disabled={isSubmitting || !domainId}
          >
            <option value="">Sélectionner un manager</option>
            {managerAccounts.map((manager) => (
              <option key={manager.id} value={manager.id}>
                {manager.companyName || `${manager.firstName} ${manager.lastName}`}
              </option>
            ))}
          </select>
          {errors.accountId && <div className="invalid-feedback">{errors.accountId}</div>}
        </div>

        {/* Sélection Type de validation */}
        <div className="mb-3">
          <label className="form-label fw-bold">Type de Validation <span className="text-danger">*</span></label>
          <select
            className={`form-select form-control-lg ${errors.validationTypeId ? "is-invalid" : ""}`}
            value={selectedValidationTypeId}
            onChange={(e) => setSelectedValidationTypeId(e.target.value)}
            disabled={isSubmitting}
          >
            <option value="">Sélectionner un type de validation</option>
            {validationTypes.map((type) => (
              <option key={type.id} value={type.id}>{type.name}</option>
            ))}
          </select>
          {errors.validationTypeId && <div className="invalid-feedback">{errors.validationTypeId}</div>}
        </div>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={isSubmitting}>Annuler</button>
        <button type="submit" className="btn btn-primary" disabled={isSubmitting || !domainId}>
          {isEditing ? "Enregistrer les modifications" : "Créer Validateur"}
        </button>
      </div>
    </form>
  );
};

export default ValidatorForm;
